const commonStyles = {
  chungungoH1: {
    fontFamily: 'Roboto Mono',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '35px',
    lineHeight: '140%',
    textTransform: 'uppercase',
  },
  chungungoH2: {
    fontFamily: 'Roboto Mono', 
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '22px',
    lineHeight: '140%',
    textTransform: 'uppercase',
  }
};

export default commonStyles;